import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-center"},[_c(VProgressCircular,{attrs:{"indeterminate":"","size":100,"color":"primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }